/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiAuthSimpleClientFromJSON(json) {
    return ApiAuthSimpleClientFromJSONTyped(json, false);
}
export function ApiAuthSimpleClientFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'environment': !exists(json, 'environment') ? undefined : json['environment'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'localId': !exists(json, 'localId') ? undefined : json['localId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}
export function ApiAuthSimpleClientToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'environment': value.environment,
        'id': value.id,
        'localId': value.localId,
        'name': value.name,
    };
}
